import { connect } from 'react-redux';

import AssistantSummary from '../components/AssistantSummary';

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(AssistantSummary);
